// This util will only work for Date type and string type dates in YYYY-MM-DD format.
const isTodayUtil = (date: string | Date): boolean => {
  const now = new Date();
  const selectedDate = new Date(date);

  return now.toDateString() === selectedDate.toDateString();
};

export default isTodayUtil;
